export default __webpack_public_path__ + "static/media/2015.35785897.png";